import React from 'react';
import universal from 'react-universal-component';
import { useSelector } from 'react-redux';
import { Transition, TransitionGroup } from 'react-transition-group';

import {
  Headline,
  BarSection,
  LandingPageContent,
  BarTextSection,
  IntroCategorySection,
  Intro
} from '../../views/LandingPage/LandingPage.styles';

const AsyncProgressBar = universal(import(`../../components/ProgressBar`));

const SubscribeThanks = (props) => {

  const email = useSelector(
    (state) => state.subscription.email
  );

  return (
    <>
      <BarSection articleThanks={props.articleThanks}>
        <AsyncProgressBar
          currentStep={2}
        />
      </BarSection>
      <TransitionGroup appear exit={false} component={null}>
        <Transition timeout={100} key="input">
          {(state) => {
            return (
              <LandingPageContent state={state} articleThanks={props.articleThanks}>
                <Headline articleThanks={props.articleThanks}>Checkpoint: You&#39;re almost there!</Headline>
                <BarTextSection>
                  <IntroCategorySection>
                    <Intro thanks articleThanks={props.articleThanks}>
                      Please check <span>{ email }</span> for a <span>QuickScope</span> message to <span>confirm your email</span>.
                      <br />
                      Don&#39;t forget to check your junk folder - just in case!
                    </Intro>
                  </IntroCategorySection>
                </BarTextSection>
              </LandingPageContent>
            );
          }}
        </Transition>
      </TransitionGroup>
    </>
  );
};

export default SubscribeThanks;
